export default __webpack_public_path__ + "static/media/invoice-bill.3e183500.svg";